import { Stack, Title, Text, Divider } from "@mantine/core";
import type { TitleSectionSettings } from "@livingsyncs/types";
import {
  FONT_SIZE,
  FONT_WEIGHT,
  LINE_HEIGHT,
  BORDER_COLOR,
  SPACING,
  BACKGROUND,
  interpolate,
} from "./designTokens";

interface FormTitleSectionProps {
  settings: TitleSectionSettings;
  interpolationContext?: Record<string, string | undefined>;
}

export function FormTitleSection({
  settings,
  interpolationContext = {},
}: FormTitleSectionProps) {
  const {
    text,
    subtitle,
    alignment = "left",
    fontSize = "xl",
    fontWeight = "bold",
    lineHeight = "normal",
    underline = false,
    borderEnabled = false,
    borderColor = "neutral",
    padding = "md",
    background,
    margin = "md",
  } = settings;

  if (!text && !subtitle) return null;

  const resolvedTitle = text ? interpolate(text, interpolationContext) : null;
  const resolvedSubtitle = subtitle
    ? interpolate(subtitle, interpolationContext)
    : null;

  const containerStyle: React.CSSProperties = {
    textAlign: alignment,
    padding: SPACING[padding],
    marginBottom: SPACING[margin],
    ...(background ? { backgroundColor: BACKGROUND[background] } : {}),
    ...(borderEnabled
      ? {
          border: `1px solid ${BORDER_COLOR[borderColor]}`,
          borderRadius: 6,
        }
      : {}),
  };

  const titleStyle: React.CSSProperties = {
    fontSize: FONT_SIZE[fontSize],
    fontWeight: FONT_WEIGHT[fontWeight],
    lineHeight: LINE_HEIGHT[lineHeight],
    ...(underline ? { textDecoration: "underline" } : {}),
  };

  return (
    <Stack gap="xs" style={containerStyle} mb={0}>
      {resolvedTitle && (
        <Title order={2} style={titleStyle}>
          {resolvedTitle}
        </Title>
      )}
      {resolvedSubtitle && (
        <Text size="sm" c="dimmed">
          {resolvedSubtitle}
        </Text>
      )}
      {borderEnabled && <Divider color={BORDER_COLOR[borderColor]} mt="xs" />}
    </Stack>
  );
}
